import React, { useContext } from 'react';
import { SimpleTable } from '@zapier/common-components';
import { Currency, Price } from '@zapier/currency';

import { useCurrentPlan } from '@zapier/design-system-revenue/src/utils';
import { PlanTier } from '@zapier/design-system-revenue/src/types';
import { CurrencyContext } from '@zapier/design-system-revenue/src/contexts/CurrencyContext';

type MeteredTiersTableProps = {
  /** If not provided, component will retrieve tiers from the user's current plan. */
  tiers?: PlanTier[];
};

const formatTier = (numTasks: number, tierIndex: number) =>
  numTasks === -1
    ? 'Any Additional'
    : `${tierIndex === 0 ? 'First' : 'Next'} ${numTasks.toLocaleString(
        'en-US'
      )}`;

const formatPrice = (price: number, currency: Currency) =>
  price === 0 ? (
    'Included'
  ) : (
    <Price currency={currency} maxDecimals={4}>
      {price}
    </Price>
  );

const formatTiers = (data: PlanTier[] = [], currency: Currency) => {
  return [
    ['Tasks', 'Price Per Task'],
    ...data.map((tier, i) => [
      formatTier(tier.numTasks, i),
      formatPrice(tier.pricePerTask, currency),
    ]),
  ];
};

export const MeteredTiersTable = ({ tiers }: MeteredTiersTableProps) => {
  const currency = useContext(CurrencyContext);
  const { currentPlan } = useCurrentPlan({ skip: !!tiers });
  const planTiers = tiers ?? currentPlan?.tiers ?? [];

  return planTiers.length > 0 ? (
    <SimpleTable data={formatTiers(planTiers, currency)} />
  ) : null;
};
